import { CalculatorConstants } from '../constants/CalculatorConstants';
import {
    CalculatorInputFieldsType,
    CalculatorInputOptions,
} from './CalculatorInputValue';
import { CalculatorHTMMode } from '../../../shared/classes/CalculatorMode';
import { CalculatorHTMItemValuesType } from '../../../shared/constants/calculator_htm_item.constant';
import { CalculatorOutputType } from '../../../shared/classes/CalculatorOutputParams';

export class CalculatorOutputFields {

    constructor(private readonly d: CalculatorInputFieldsType,
                private readonly mode: CalculatorHTMMode) {
    }

    private g(key: keyof CalculatorInputFieldsType): number {
        const formatValueFunction = CalculatorInputOptions[key]?.formatValueFunction;
        const value = +(this.d[key] || 0);

        return formatValueFunction?.(value) || value;
    }

    private J8 = this.g('average_number_scans');
    private J10 = this.g('average_rembursement');
    private J18 = this.g('facility_opening_hours');
    private J20 = this.g('facility_opening_days');
    private J22 = this.g('percent_exam_event');
    private S8 = this.g('radiologist');
    private S10 = this.g('technologist');
    private S12 = this.g('rate_HTM_org_perfomance') as CalculatorHTMItemValuesType;
    private S18 = this.g('technologist_wages_per_hour');
    private S20 = this.g('radiologist_wages_per_hour');
    private S22 = this.g('inHouse_engineer_cost');
    private C82 = this.g('admin_fee_rescheduledPatient');
    private C182 = this.g('technologist_overtime_percent');
    private C202 = this.g('radiologist_overtime_percent');

    private average_number_exam_hour = this.J8 / this.J18;
    private yearly_technologist_radiologist_wages = this.J18 * (this.S8 * this.S20 + this.S10 * this.S18) * this.J20;
    private average_number_exam_year = this.J8 * this.J20;
    private estimated_revenue_year = this.average_number_exam_year * this.J10;

    private on_watch_predict_examinations_saved = Math.ceil((CalculatorConstants.M18 + CalculatorConstants.N18) * this.average_number_exam_hour * (1 - this.J22));
    private on_watch_predict_revenue_saved = this.on_watch_predict_examinations_saved * this.J10;
    private on_watch_predict_operating_hours_saved = CalculatorConstants.M18 + CalculatorConstants.N18;
    private on_watch_predict_staff_iddle_time_cost_avoidance = this.on_watch_predict_operating_hours_saved * (this.S8 * this.S20 + this.S10 * this.S18);
    private on_watch_predict_staff_overtime_cost_avoidance = ((this.on_watch_predict_examinations_saved * this.J22) / this.average_number_exam_hour) * (this.S8 * this.S20 * (1 + this.C202) + this.S10 * this.S18 * (1 + this.C182))
    private on_watch_predict_average_admin_fee_costs_avoidance_for_rescheduling_exams = this.on_watch_predict_examinations_saved * this.C82;
    private on_watch_predict_labor_productivity_in_hours = CalculatorConstants.I37[this.S12];
    private on_watch_predict_labor_productivity = this.on_watch_predict_labor_productivity_in_hours * this.S22;
    private on_watch_predict_estimated_benefits = this.on_watch_predict_revenue_saved
        + this.on_watch_predict_staff_iddle_time_cost_avoidance
        + this.on_watch_predict_staff_overtime_cost_avoidance
        + this.on_watch_predict_average_admin_fee_costs_avoidance_for_rescheduling_exams
        + (this.mode === CalculatorHTMMode.HTM ? this.on_watch_predict_labor_productivity : 0);

    private on_watch_examinations_saved = Math.ceil((CalculatorConstants.O18 + CalculatorConstants.P18) * this.average_number_exam_hour * (1 - this.J22));
    private on_watch_revenue_saved = this.on_watch_examinations_saved * this.J10;
    private on_watch_operating_hours_saved = CalculatorConstants.O18 + CalculatorConstants.P18;
    private on_watch_staff_iddle_time_cost_avoidance = this.on_watch_operating_hours_saved * (this.S8 * this.S20 + this.S10 * this.S18);
    private on_watch_staff_overtime_cost_avoidance = ((this.on_watch_examinations_saved * this.J22) / this.average_number_exam_hour) * (this.S8 * this.S20 * (1 + this.C202) + this.S10 * this.S18 * (1 + this.C182));
    private on_watch_average_admin_fee_costs_avoidance_for_rescheduling_exams = (this.on_watch_examinations_saved * this.C82);
    private on_watch_labor_productivity_in_hours = CalculatorConstants.J37[this.S12];
    private on_watch_labor_productivity = this.on_watch_labor_productivity_in_hours * this.S22;
    private on_watch_estimated_benefits = this.on_watch_revenue_saved
        + this.on_watch_staff_iddle_time_cost_avoidance
        + this.on_watch_staff_overtime_cost_avoidance
        + this.on_watch_average_admin_fee_costs_avoidance_for_rescheduling_exams
        + (this.mode === CalculatorHTMMode.HTM ? this.on_watch_labor_productivity : 0);

    private break_fix_exams_loss = Math.ceil((CalculatorConstants.Q18 + CalculatorConstants.R18) * this.average_number_exam_hour * (1 - this.J22));
    private break_fix_revenue_loss = this.break_fix_exams_loss * this.J10;
    private operating_hours_lost = CalculatorConstants.Q18 + CalculatorConstants.R18;
    private staff_cost_due_to_iddle_time = this.operating_hours_lost * (this.S8 * this.S20 + this.S10 * this.S18);
    private staff_overtime_cost = ((this.break_fix_exams_loss * this.J22) / this.average_number_exam_hour) * (this.S8 * this.S20 * (1 + this.C202) + this.S10 * this.S18 * (1 + this.C182));
    private average_admin_fee_costs_for_rescheduling_exams = this.break_fix_exams_loss * this.C82;
    private labor_productivity_in_hours = CalculatorConstants.K37;
    private labor_productivity = this.labor_productivity_in_hours * this.S22;
    private estimated_Loss = this.break_fix_revenue_loss
        + this.staff_cost_due_to_iddle_time
        + this.staff_overtime_cost
        + this.average_admin_fee_costs_for_rescheduling_exams
        + (this.mode === CalculatorHTMMode.HTM ? this.labor_productivity : 0);

    values: CalculatorOutputType = {
        average_number_exam_hour: {
            value: this.average_number_exam_hour || 0,
            label: 'Average number of exam per hour',
        },
        yearly_technologist_radiologist_wages: {
            value: this.yearly_technologist_radiologist_wages || 0,
            label: 'Yearly Technologist & Radiologist Wages',
            options: {
                displayCurrency: true
            }
        },
        average_number_exam_year: {
            value: this.average_number_exam_year || 0,
            label: 'Average number of exams per year',
        },
        estimated_revenue_year: {
            value: this.estimated_revenue_year || 0,
            label: 'Estimated revenue per year',
            options: {
                displayCurrency: true
            }
        },
        on_watch_predict_examinations_saved: {
            value: this.on_watch_predict_examinations_saved || 0,
            label: '# Examinations Saved',
            options: {
                displayCurrency: true
            }
        },
        on_watch_predict_revenue_saved: {
            value: this.on_watch_predict_revenue_saved || 0,
            label: '# Revenue Saved',
            options: {
                displayCurrency: true
            }
        },
        on_watch_predict_operating_hours_saved: {
            value: this.on_watch_predict_operating_hours_saved || 0,
            label: '# Operating hours Saved',
        },
        on_watch_predict_staff_iddle_time_cost_avoidance: {
            value: this.on_watch_predict_staff_iddle_time_cost_avoidance || 0,
            label: 'Staff idle time cost avoidance',
            options: {
                displayCurrency: true
            }
        },
        on_watch_predict_staff_overtime_cost_avoidance: {
            value: this.on_watch_predict_staff_overtime_cost_avoidance || 0,
            label: 'Staff Overtime Cost avoidance',
            options: {
                displayCurrency: true
            }
        },
        on_watch_predict_average_admin_fee_costs_avoidance_for_rescheduling_exams: {
            value: this.on_watch_predict_average_admin_fee_costs_avoidance_for_rescheduling_exams || 0,
            label: 'Average Admin Fee costs avoidance for rescheduling Exams',
            options: {
                displayCurrency: true
            }
        },
        on_watch_predict_labor_productivity_in_hours: {
            value: this.on_watch_predict_labor_productivity_in_hours || 0,
            label: 'Labor Productivity in Hours',
            options: {
                isHTMMode: true
            }
        },
        on_watch_predict_labor_productivity: {
            value: this.on_watch_predict_labor_productivity || 0,
            label: 'Labor Productivity',
            options: {
                isHTMMode: true,
                displayCurrency: true
            }
        },
        on_watch_predict_estimated_benefits: {
            value: this.on_watch_predict_estimated_benefits || 0,
            label: 'Estimated Benefits',
            options: {
                displayCurrency: true
            }
        },
        on_watch_examinations_saved: {
            value: this.on_watch_examinations_saved || 0,
            label: ' # Examinations Saved',
        },
        on_watch_revenue_saved: {
            value: this.on_watch_revenue_saved || 0,
            label: ' # Revenue Saved',
            options: {
                displayCurrency: true
            }
        },
        on_watch_operating_hours_saved: {
            value: this.on_watch_operating_hours_saved || 0,
            label: '# Operating hours Saved',
        },
        on_watch_staff_iddle_time_cost_avoidance: {
            value: this.on_watch_staff_iddle_time_cost_avoidance || 0,
            label: 'Staff idle time cost avoidance',
            options: {
                displayCurrency: true
            }
        },
        on_watch_staff_overtime_cost_avoidance: {
            value: this.on_watch_staff_overtime_cost_avoidance || 0,
            label: 'Staff Overtime Cost avoidance',
            options: {
                displayCurrency: true
            }
        },
        on_watch_average_admin_fee_costs_avoidance_for_rescheduling_exams: {
            value: this.on_watch_average_admin_fee_costs_avoidance_for_rescheduling_exams || 0,
            label: 'Average Admin Fee costs avoidance for rescheduling Exams',
            options: {
                displayCurrency: true
            }
        },
        on_watch_labor_productivity_in_hours: {
            value: this.on_watch_labor_productivity_in_hours || 0,
            label: 'Labor Productivity in Hours',
            options: {
                isHTMMode: true
            }
        },
        on_watch_labor_productivity: {
            value: this.on_watch_labor_productivity || 0,
            label: 'Labor Productivity',
            options: {
                isHTMMode: true,
                displayCurrency: true
            }
        },
        on_watch_estimated_benefits: {
            value: this.on_watch_estimated_benefits || 0,
            label: 'Estimated Benefits',
            options: {
                displayCurrency: true
            }
        },
        break_fix_exams_loss: {
            value: this.break_fix_exams_loss || 0,
            label: 'Break & Fix Exams loss',
        },
        break_fix_revenue_loss: {
            value: this.break_fix_revenue_loss || 0,
            label: 'Break & Fix revenue Loss',
            options: {
                displayCurrency: true
            }
        },
        operating_hours_lost: {
            value: this.operating_hours_lost || 0,
            label: '# Operating hours Lost',
        },
        staff_cost_due_to_iddle_time: {
            value: this.staff_cost_due_to_iddle_time || 0,
            label: 'Staff cost due to idle time',
            options: {
                displayCurrency: true
            }
        },
        staff_overtime_cost: {
            value: this.staff_overtime_cost || 0,
            label: 'Staff Overtime cost',
            options: {
                displayCurrency: true
            }
        },
        average_admin_fee_costs_for_rescheduling_exams: {
            value: this.average_admin_fee_costs_for_rescheduling_exams || 0,
            label: 'Average Admin Fee costs for rescheduling Exams',
        },
        labor_productivity_in_hours: {
            value: this.labor_productivity_in_hours || 0,
            label: 'Labor Productivity in Hours',
            options: {
                isHTMMode: true
            }
        },
        labor_productivity: {
            value: this.labor_productivity || 0,
            label: 'Labor Productivity',
            options: {
                isHTMMode: true
            }
        },
        estimated_Loss: {
            value: this.estimated_Loss || 0,
            label: 'Estimated Loss',
            options: {
                displayCurrency: true
            }
        },
    };

}
